import { render, staticRenderFns } from "./LandMarketLeft.vue?vue&type=template&id=6d56f624&scoped=true&"
import script from "./LandMarketLeft.vue?vue&type=script&lang=js&"
export * from "./LandMarketLeft.vue?vue&type=script&lang=js&"
import style0 from "./LandMarketLeft.vue?vue&type=style&index=0&id=6d56f624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56f624",
  null
  
)

export default component.exports